$(function(){
    var $infoScreen = $('#info-screen');
    window._diesteLeaderboardActivePerson = {};
    window._diesteLeaderboardAllPersons = Array.from($('.person')).map(function(p){
        return $(p).data('info');
    });
    $('.person').on('click', function(){
        var $person = $(this);
        activePerson = toggleInfo($infoScreen, $person);
    });
    $('#close-info').on('click', function(){
        toggleInfo($infoScreen);
    });
    $('#next-info').on('click', function(){
        var active = window._diesteLeaderboardAllPersons.indexOf(window._diesteLeaderboardActivePerson);
        var next = window._diesteLeaderboardAllPersons[active + 1];
        if (!next) {
            return;
        }
        setInfo($infoScreen, next);
    });
    $('#prev-info').on('click', function(){
        var active = window._diesteLeaderboardAllPersons.indexOf(window._diesteLeaderboardActivePerson);
        var prev = window._diesteLeaderboardAllPersons[active - 1];
        if (!prev) {
            return;
        }
        setInfo($infoScreen, prev);
    });
});
  
function toggleInfo($infoScreen, $person){
    if ($person) {
        var data = $person.data('info');
        console.log(data);
        window._diesteLeaderboardActivePerson = data;
        $('.info-picture').css('--img', 'url("' + data.photo + '")');  
        $('.info-picture').css('--img-mobile', 'url("' + data.photo + '")');
        if (data.photo_mobile) {
            $('.info-picture').css('--img-mobile', 'url("' + data.photo_mobile + '")');  
        }  
        $('.info-name').html(data.name);  
        $('.info-title').html(data.position);  
        $('.info-person-description').html(data.description);  
    }
    $infoScreen.toggleClass('open');
}

function setInfo($infoScreen, data){
    window._diesteLeaderboardActivePerson = data;
        console.log(data);
        $('.info-picture').css('--img', 'url("' + data.photo + '")');  
    $('.info-picture').css('--img-mobile', 'url("' + data.photo + '")');
    if (data.photo_mobile) {
        $('.info-picture').css('--img-mobile', 'url("' + data.photo_mobile + '")');  
    }  
    $('.info-name').html(data.name);  
    $('.info-title').html(data.position);  
    $('.info-person-description').html(data.description);  
}